import { ToastContainer } from 'react-toastify'
import '../../styles/analytics.css'
import PriceCard from './component/pricecards'
import { PayPalScriptProvider } from '@paypal/react-paypal-js'
import useChatbotLoader from '../../util/chatbotloader'
import { useEffect } from 'react'

const SubscriptionPage = () => {
  // useChatbotLoader("","");
  console.log(process.env.REACT_APP_PAYPAL_CLIENT_ID)
  return (
    <div className='relative py-3 px-3'>
      <div className='flex-1 h-auto pb-10 bg-white mt-[15px] rounded-[16px] shadow-md'>
        <div className='p-4 w-full border-b mb-4'>
          <h1 class='text-[#252530] font-extrabold text-[23px] '>
            Subscription
          </h1>{' '}
        </div>
        <div className='w-full'>
          <div className='flex flex-col justify-center items-center'>
            <h2 className='font-semibold leading-7 text-[19px]'>
              Scalable Pricing That Adapts to Your Business
            </h2>
            <p class='font-medium  text-[#252530] leading-7 text-[12px]'>
              Choose a plan that grows with you, ensuring you only pay for what
              you need.
            </p>
            <div className='mt-3 flex justify-center'>
              <div className='block'>
                <div className='flex bg-[#1F1929] bg-opacity-0 w-full sm:w-[207px] pl-1 pr-2 h-[39px] rounded-[40px] text-white justify-center items-center'>
                  <button className='bg-[#7C50DD] rounded-[40px] w-[104px] cursor-text flex justify-center items-center pr-[10px] pb-[8px] pl-[5px] pt-[8px] text-[10px] font-bold'>
                    Monthly
                  </button>
                  {/* <button className='hover:bg-[#7C50DD] rounded-[40px] w-[104px] flex justify-center items-center pr-[10px] pb-[8px] pl-[5px] pt-[8px] text-[10px] font-bold'>
                    Annual
                  </button> */}
                </div>
              </div>
            </div>
            {/* <p class='font-medium  text-[#D37C2E] leading-7 text-[11px]'>
              Limited Time Period Offer Unlimited Store{' '}
            </p> */}
          </div>
          {/* price cards */}
          <PayPalScriptProvider
            options={{
              vault: true,
              intent: 'subscription',
              clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID
            }}
          >

            <PriceCard />
          </PayPalScriptProvider>
        </div>
      </div>
      <ToastContainer/>
    </div>
  )
}

export default SubscriptionPage
